// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"44c670de","455":"45dfd44c","977":"44d044cb"}[chunkId] + ".chunk.js";
};